module.exports = __webpack_public_path__ + "static/media/step-forward.7e131474.svg";